import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableOrgBillingWrap = Loadable({
  loader: function loader() {
    return import('../OrgBillingWrap.jsx');
  },
  loading: ComponentLoading
});
export default LoadableOrgBillingWrap;